<template>
  <div class="section-row">
    <header class="header">
      <div class="header__content">
        <h2 class="header__title">
          {{ title }}
        </h2>
        <span class="header__secondary-text">
          <template v-if="!$slots.default">
            {{ $t("message.storeLocator.faq.noFaq") }}
          </template>
        </span>
      </div>
      <div class="header__actions">
        <ui-button
          v-if="expandable && $slots.default"
          :icon="expandableIcon"
          shadow
          outlined
          @click="isExpanded = !isExpanded"
        >
          {{ expandableText }}
        </ui-button>
        <slot name="actions" />
      </div>
    </header>
    <div
      v-if="$slots.default"
      v-show="isExpanded || !expandable"
      class="section-row__content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorExpandable",
  props: {
    title: {
      type: String,
      required: true
    },
    expandable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    expandableIcon() {
      return this.isExpanded ? "icon-arrow-up" : "icon-arrow-down";
    },
    expandableText() {
      return this.isExpanded
        ? this.$t("message.common.collapse")
        : this.$t("message.common.expand");
    }
  }
};
</script>

<style lang="scss" scoped>
.section-row {
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;

  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing * 2;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing * 3;
  position: relative;
  padding-left: $spacing * 2.5;

  &__content {
    display: flex;
    align-items: center;
    gap: $spacing;
  }

  &__title {
    font-family: "Montserrat", sans-serif;
    @include font-size(16px);
    font-weight: 500;
    line-height: 1em;
  }

  &__secondary-text {
    @include font-size(14px);
    color: $gray;
    line-height: 1.05em;
    align-self: flex-end;
  }

  &:before {
    position: absolute;
    content: "";
    display: block;
    width: 3px;
    height: 32px;
    background-color: $lime;
    left: 0;
  }

  &__actions {
    display: flex;
    gap: $spacing;
  }
}
</style>
